import React from "react";
import { GKContent, Col, Container, Row } from "@granular/gds-ux-components";

import { ChildrenProp } from "../../types";

const ResponsiveShell: React.FC<ChildrenProp> = ({ children }) => (
  <GKContent>
    <Container className={"mt-4"}>
      <Row>
        <Col lg={{ size: 8, offset: 2 }}>
          {children}
          {/*
            This is fugly and old-school. But it does the trick simply.
            Why is it here? Because customers need to be able to scroll the
            "Terms of Service" into view when they're in `sm`. You cannot
            affix a `pb-md-5` class to the enclosing <Col> because you
            will have a fixed bottom submit bar. Hence these.
          */}
          <div className="d-md-none">
            <br />
            <br />
            <br />
          </div>
        </Col>
      </Row>
    </Container>
  </GKContent>
);

export default ResponsiveShell;
